// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1CnvNGUul1qbMvXTcITbkH {\r\n    position: relative;    \r\n}\r\n\r\n._3E3Fu6zYIdlaILhsri2A8H {\r\n    position: relative;\r\n    z-index: 2;\r\n    \r\n}\r\n\r\n._1bRnse06EdRCsQhOa3Lgi9 {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: calc(100%  - 8px);\r\n    opacity: 0;\r\n\r\n    z-index: 1;\r\n\r\n    padding-top: 8px;\r\n\r\n    background-color: var(--action);\r\n    color: var(--on-action);\r\n    border-bottom-left-radius: 5px;\r\n    border-bottom-right-radius: 5px;\r\n\r\n    font-size: 11px;\r\n}\r\n\r\n\r\n._2S43mUo1XGfNMveuoOHeYt {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n\r\n    height: 36px;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 0 12px;\r\n\r\n}", ""]);
// Exports
exports.locals = {
	"container": "_1CnvNGUul1qbMvXTcITbkH",
	"content": "_3E3Fu6zYIdlaILhsri2A8H",
	"menu": "_1bRnse06EdRCsQhOa3Lgi9",
	"item": "_2S43mUo1XGfNMveuoOHeYt"
};
module.exports = exports;
